<script setup lang="ts">
/**
 * A short status, in a colour that says how it stands.
 *
 * Four tones and no more: something fine, something to look at, something
 * wrong, and something merely informative. The words carry the meaning; the
 * colour only makes a list of them scannable.
 */
withDefaults(defineProps<{ tone?: 'good' | 'warn' | 'danger' | 'neutral' }>(), { tone: 'neutral' })
</script>

<template>
  <span class="chip" :class="`chip--${tone}`"><slot /></span>
</template>

<style scoped>
.chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 20px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  font-size: var(--text-xs, 11px);
  font-weight: 600;
  white-space: nowrap;
}

.chip::before {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  content: '';
}

.chip--good {
  background: var(--color-success-soft);
  color: var(--good);
}

.chip--warn {
  background: var(--color-warning-soft);
  color: var(--warn);
}

.chip--danger {
  background: var(--color-danger-soft);
  color: var(--danger);
}

.chip--neutral {
  background: var(--panel-hover);
  color: var(--ink-soft);
}
</style>
